import { NgModule } from '@angular/core';
import { FeatherModule } from 'angular-feather';
import { 
  DollarSign,
  Clock,
  Users,
  CheckCircle
} from 'angular-feather/icons';

const icons = {
  DollarSign,
  Clock,
  Users,
  CheckCircle
};

@NgModule({
  imports: [
    FeatherModule.pick(icons)
  ],
  exports: [
    FeatherModule
  ]
})
export class IconsModule { } 